import { Link, P, Divider, Modal, openModalByName, T2 } from 'ia-react-core';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ClaimsContext from '../Claims/ClaimsContext';
import { StyledHeader, StyledIcon, StyledWrapper } from './ConsultationModeHeader.styles';

export interface ConsultationModeHeaderProps {
}

const ConsultationModeHeader: FC<ConsultationModeHeaderProps> = () => {
  const { t } = useTranslation('ConsultationModeHeader');
  const dispatch = useDispatch();
  const ctx = useContext(ClaimsContext);

  if (!ctx?.isDCA) {
    return null;
  }

  return (
    <>
      <Modal name="consultationModeModal">
        <T2>{t('modalTitle')}</T2>
        <P>
          {t('modalText')}
        </P>
      </Modal>
      <StyledHeader>
        <StyledWrapper data-testid="consultationModeHeader">
          <StyledIcon width={24} />
          <P strong>
            {t('headerText')}
            <Link
              href="#"
              onClick={(e) => {
                e.preventDefault();
                dispatch(openModalByName('consultationModeModal'));
              }}
            >
              {t('modalLink')}
            </Link>
          </P>
        </StyledWrapper>
      </StyledHeader>
      <Divider />
    </>
  );
};

export default ConsultationModeHeader;
